<template>
  <div class="d-flex flex-column mx-auto" style="max-width: 265px">
    <div v-if="audioRecorded" class="align-self-center w-100 audioPlayer">
      <div v-if="audioPlaying" class="audioPlayerContainer" @click="toggleAudioPlayer()">
        <v-icon class="audioPlayerIcon">mdi-pause-circle-outline</v-icon>
        <span class="audioPlayerText">Pausar áudio</span>
      </div>
      <div v-else class="audioPlayerContainer" @click="toggleAudioPlayer()">
        <v-icon class="audioPlayerIcon">mdi-play-circle-outline</v-icon>
        <span class="audioPlayerText">Ouvir áudio</span>
      </div>
    </div>
    <div v-if="!audioRecorded" class="record-button text-center">
      <v-btn depressed class="my-2" color="primary" @mousedown="toggleRecordingState()" @mouseup="toggleRecordingState()">
        <v-icon left>mdi-microphone</v-icon> {{ audioButtonText }}
      </v-btn>
      <small class="d-block mx-auto">Mantenha pressionado para gravar</small>
    </div>
    <v-btn depressed v-if="audioRecorded && canshowRecAgain" color="primary" class="my-2" @click="recordAgain()">
      Gravar novamente
    </v-btn>
  </div>
</template>

<script>
import functions from '@/components/Utils/Class/functions.js'

export default {
  props: {
    audioFile: {
      type: Blob,
      required: false,
      default: null
    }
  },
  data () {
    return {
      audioRecorder: null,
      isRecording: false,
      audioRecorded: false,
      canshowRecAgain: false,
      audioInputPoint: null,
      audioButtonText: 'Começar Gravação',
      audioPlayer: null,
      audioPlaying: false
    }
  },
  mounted () {
    this.audioRecorder = functions.recordAudio()
    this.setAudioFile()
  },
  watch: {
    audioFile () {
      this.setAudioFile()
    }
  },
  methods: {
    setAudioFile () {
      if (this.audioFile) {
        const fileUrl = window.URL.createObjectURL(this.audioFile)
        this.audioPlayer = new Audio(fileUrl)
        this.audioRecorded = true
      }
    },
    toggleRecordingState () {
      const self = this
      if (self.audioRecorder) {
        if (!self.isRecording) {
          self.audioRecorder.start().then(() => {
            self.isRecording = true
            self.audioButtonText = 'Terminar Gravação'
          }).catch((e) => {
            self.audioButtonText = 'Começar Gravação'
            self.$toasted.global.error({ message: 'Não é possível gravar o áudio, nenhum microfone detectado. Conecte um microfone e atualize a página' })
          })
        } else {
          self.audioRecorder.stop().then(function (res) {
            self.isRecording = false
            self.audioPlayer = res.audioPlayer
            self.recordedEmit(res.audioFile)
            self.audioRecorded = true
            self.canshowRecAgain = true
          }).catch((e) => {
            self.audioButtonText = 'Começar Gravação'
            self.isRecording = false
            self.audioPlayer = null
            self.recordedEmit(null)
            self.audioRecorded = false
            self.canshowRecAgain = false
            self.$toasted.global.error({ message: 'Não foi possível concluir o áudio, tente gravar novamente' })
          })
        }
      } else {
        self.audioButtonText = 'Começar Gravação'
        self.$toasted.global.error({ message: 'Não é possível gravar o áudio, nenhum microfone detectado. Conecte um microfone e atualize a página' })
      }
    },
    toggleAudioPlayer () {
      const self = this
      if (self.audioPlaying) {
        if (self.audioPlayer) {
          self.audioPlayer.pause()
          self.audioPlaying = !self.audioPlaying
        }
      } else {
        if (self.audioPlayer) {
          self.audioPlayer.play()
          self.audioPlaying = !self.audioPlaying
        }
      }
    },
    recordAgain () {
      this.audioRecorded = false
      this.audioButtonText = 'Começar Gravação'
    },
    hideButtonRecAudio () {
      this.canshowRecAgain = false
    },
    recordedEmit (file) {
      this.$emit('recorded', file)
    }
  }
}
</script>

<style>

</style>
